<template>
    <ValidationObserver :ref="stepName" v-slot="observer">
        <div v-for="(field,name) in fields" :key="name" class="field-container">
            <component :is="field._component" :key="name" :name="name" :field="field" :step="step"></component>
        </div>

        <!--<a href="#">J’utilise un compte non portugais</a>-->

        <b-button type="button next-button is-primary" :disabled="block_form" v-html="step._button" @click="nextStep()"></b-button>

        <p class="paytrust-text">Vous restez libre d'interrompre votre abonnement à tout moment.</p>
        <img class="paytrust-img" src="/images/fr_multigift/pay-trust.png" alt="Universal SSL">
    </ValidationObserver>
</template>

<script>
import mixin from "../../../travel_step_mixin";
import form_step_mixin from '../../../form_step_mixin'
import {Text} from "../../../../../../models/fields/Text";
import {Checkbox} from "../../../../../../models/fields/Checkbox";
import {MaskPattern} from "../../../../../../models/fields/Features/mask/MaskPattern";
import {sync} from "vuex-pathify";

export default {
    mixins: [mixin,form_step_mixin],
    data() {
        return {
            fields: {
                iban: new Text()
                    .label('Indiquez votre numéro IBAN')
                    .required()
                    .validation({regex: /^(BE)[0-9]{14}$/})
                    .mask(new MaskPattern('{BE}** **** **** ****').showPlaceholder('X')),
            }
        }
    },
    watch:{
        'iban':{
            handler: function (val, oldVal){
                this.iban = _.toUpper(val)
            },
            immediate: true,
        },
    },
    computed: {
        iban: sync('form_data/iban'),
    }
}
</script>
